@if (!isLoading) {
    <mat-accordion [hideToggle]="true">
        @for (attachment of attachments; track attachment) {
            <div class="mb-3">
                <mat-expansion-panel
                    class="card shadow v3"
                    #matExpansionPanel="matExpansionPanel"
                    [disabled]="IsNone(attachment) || IsPDF(attachment)"
                    [attr.data-sb-qa]="attachment.Filename">
                    <mat-expansion-panel-header
                        collapsedHeight="auto"
                        expandedHeight="auto"
                        [ngClass]="{ 'cursor-default': !ShowShowButton(attachment) }">
                        <div class="d-grid gap-2 p-3 w-100">
                            <div class="d-flex flex-row justify-content-between">
                                <div class="d-flex align-items-center">
                                    <p
                                        class="typography-semibold typography-caption-large text-break"
                                        [attr.data-sb-qa]="'$$DisplayingFileName_' + attachment.Filename"
                                        data-clarity-mask="true">
                                        {{ attachment.Filename | formatFilename }}
                                    </p>
                                </div>
                                <div class="d-flex align-items-start">
                                    @if (canEdit && canDelete) {
                                        <lib-menu-button
                                            class="ps-2"
                                            [prefixIcon]="Icon.Common.MoreVert"
                                            [iconOnly]="true"
                                            [kind]="ButtonKind.NeutralTertiary"
                                            (click)="$event.stopPropagation()"
                                            [hasCaretSuffix]="false">
                                            <lib-menu-item
                                                [prefixIcon]="Icon.Common.Edit"
                                                i18n-label="@@CommonEditButton"
                                                label="Edit"
                                                (clicked)="EditAttachment(attachment)"></lib-menu-item>
                                            <lib-menu-item
                                                i18n-label="@@CommonDeleteButton"
                                                label="Delete"
                                                [prefixIcon]="Icon.Common.DeleteOutline"
                                                (clicked)="DeleteAttachment(attachment)"></lib-menu-item>
                                        </lib-menu-button>
                                    } @else if (canEdit) {
                                        <lib-button
                                            class="ps-2"
                                            [prefixIcon]="Icon.Common.Edit"
                                            [kind]="ButtonKind.Tertiary"
                                            [iconOnly]="true"
                                            (clicked)="EditAttachment(attachment); $event.stopPropagation()"></lib-button>
                                    } @else if (canDelete) {
                                        <lib-button
                                            class="ps-2"
                                            [prefixIcon]="Icon.Common.DeleteOutline"
                                            (clicked)="DeleteAttachment(attachment); $event.stopPropagation()"
                                            [iconOnly]="true"
                                            [kind]="ButtonKind.Tertiary"></lib-button>
                                    }
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                @if (IsImage(attachment)) {
                                    <lib-icon
                                        [icon]="Icon.Common.FileImage"
                                        [size]="IconSize.Small"></lib-icon>
                                } @else if (IsPlayable(attachment)) {
                                    <lib-icon
                                        [icon]="Icon.Common.VideoFileOutline"
                                        [size]="IconSize.Small"></lib-icon>
                                } @else if (IsPDF(attachment) || IsNone(attachment)) {
                                    <lib-icon
                                        [icon]="Icon.Common.FileDescriptionOutline"
                                        [size]="IconSize.Small"></lib-icon>
                                }
                                <div class="typography-caption base-300 ps-1">
                                    {{ attachment.Filename | formatFilename: 'ext' }}
                                </div>
                                <!-- eslint-disable-next-line -->
                                <p class="typography-caption neutral-200 px-2">|</p>
                                <div class="typography-caption base-300">
                                    {{ attachment.FileSize | formatFilesize }}
                                </div>
                            </div>

                            @if (HasDescription(attachment)) {
                                <p
                                    [attr.data-sb-qa]="'$$DisplayingFileDescription_' + attachment.Filename"
                                    class="typography-caption base-100 text-break"
                                    data-clarity-mask="true">
                                    {{ GetDescription(attachment) }}
                                </p>
                            }

                            <div class="d-flex flex-row justify-content-between align-items-center">
                                <div class="d-flex flex-row gap-space-8">
                                    @if (!hideDownloadButton && attachment.DownloadURL) {
                                        <lib-button
                                            class="me-2"
                                            [prefixIcon]="Icon.Common.Download"
                                            [kind]="ButtonKind.NeutralLink"
                                            [qaTag]="'download-link-' + attachment.Filename"
                                            (clicked)="DownloadAttachment(attachment); $event.stopPropagation()">
                                            <ng-container
                                                label
                                                i18n="@@CommonDownloadLabel">
                                                Download
                                            </ng-container>
                                        </lib-button>
                                    }
                                    @if (!hideViewButton && attachment.ViewURL && !IsNone(attachment)) {
                                        <lib-button
                                            class="me-2"
                                            [prefixIcon]="Icon.Common.VisibilityOutline"
                                            [kind]="ButtonKind.NeutralLink"
                                            [qaTag]="'view-link-' + attachment.Filename"
                                            (clicked)="ViewAttachment(attachment); $event.stopPropagation()">
                                            <ng-container
                                                label
                                                i18n="@@CommonViewLabel">
                                                View
                                            </ng-container>
                                        </lib-button>
                                    }
                                </div>
                                @if (!IsPanelExpanded(matExpansionPanel) && ShowShowButton(attachment)) {
                                    <lib-button
                                        [prefixIcon]="Icon.Common.ExpandMore"
                                        [iconOnly]="true"
                                        [kind]="ButtonKind.NeutralTertiary"
                                        (clicked)="matExpansionPanel.toggle()">
                                        <ng-container
                                            label
                                            i18n="@@CommonAttachmentShowLabel">
                                            Show
                                        </ng-container>
                                    </lib-button>
                                } @else if (ShowShowButton(attachment)) {
                                    <lib-button
                                        [prefixIcon]="Icon.Common.ExpandLess"
                                        [iconOnly]="true"
                                        [kind]="ButtonKind.NeutralTertiary"
                                         (clicked)="matExpansionPanel.toggle()">
                                        <ng-container
                                            label
                                            i18n="@@CommonAttachmentHideLabel">
                                            Hide
                                        </ng-container>
                                    </lib-button>
                                }
                            </div>
                        </div>
                    </mat-expansion-panel-header>

                    <div class="p-3 w-100">
                        <!-- Expanded content/preview goes here! -->
                        @if (IsImage(attachment)) {
                            <div style="text-align: center">
                                <img
                                    style="max-width: 100%"
                                    [src]="attachment.ViewURL" />
                            </div>
                        }
                    </div>
                </mat-expansion-panel>
            </div>
        }
    </mat-accordion>
} @else {
    <div class="form-field-loading-text-area"></div>
}
